module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-17.38004ce1.svg";